<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">
        <div class="alert-icon alert-icon-rotated">
            <img src="assets/icon/warning-icon.webp">
        </div>
        <div class="title">{{ header }}</div>
        <div class="alert-icon">
            <img src="assets/icon/warning-icon.webp">
        </div>
    </div>
    <div class="sopo-popup-text">
        <div class="description">
            <span>All crypto withdrawals are processed in USDC on Ethereum and Solana. </span>
            <br>
            <span style="color: red;">If you’re using a <span style="font-weight: bolder;">PayPal</span> or <span style="font-weight: bolder;">Venmo</span> crypto wallet, you must check the box
                below.</span>
            <br>
            <span style="font-weight: bolder;">These wallets do not support USDC, and your funds will be lost if you
                don’t.</span>
            <br>
            <hr>
            <div class="checkbox-section">
                <ion-checkbox [(ngModel)]="checkboxChecked" class="alert-checkbox"></ion-checkbox>
                <label class="checkbox-label">I HAVE READ AND UNDERSTAND THIS MESSAGE.</label>
            </div>
            <hr>
            <br>
            <span>This warning applies only to PayPal and Venmo crypto wallets. </span>
            <br>
            <span>Coinbase, Phantom, MetaMask, and Uniswap users can ignore this message.</span>
        </div>
    </div>
    <div class="sopo-popup-button-container">
        <div [ngClass]="checkboxChecked ? 'sopo-popup-green-button ion-activatable clickable' : 'sopo-popup-grey-button'" (click)="close()">
                {{ okText }}
                <ion-ripple-effect *ngIf="checkboxChecked"></ion-ripple-effect>
        </div>
    </div>
</div>